
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_MessageBoxMarketerialLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_MessageBoxMarketerialLayout__root","header":"wds_1_209_0_MessageBoxMarketerialLayout__header","headerImage":"wds_1_209_0_MessageBoxMarketerialLayout__headerImage","headerImageComponent":"wds_1_209_0_MessageBoxMarketerialLayout__headerImageComponent","title":"wds_1_209_0_MessageBoxMarketerialLayout__title","content":"wds_1_209_0_MessageBoxMarketerialLayout__content","emptyButtonsContainer":"wds_1_209_0_MessageBoxMarketerialLayout__emptyButtonsContainer","buttonsContainer":"wds_1_209_0_MessageBoxMarketerialLayout__buttonsContainer","secondaryButtonContainer":"wds_1_209_0_MessageBoxMarketerialLayout__secondaryButtonContainer","bottomChildren":"wds_1_209_0_MessageBoxMarketerialLayout__bottomChildren","close":"wds_1_209_0_MessageBoxMarketerialLayout__close"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




